const templates = [
  {
    id: 1,
    category: "Birthday",
    title: "Sunset Birthday",
    previewText: "Wishing you joy, laughter, and a day full of memories.",
    description: "A warm birthday card with your name on a golden sunset background.",
    image:
      "https://images.unsplash.com/photo-1509223197845-458d87318791?auto=format&fit=crop&w=900&q=80",
    isPremium: false,
  },
  {
    id: 2,
    category: "Festival",
    title: "Festival Glow",
    previewText: "Sending bright festival wishes with your personal touch.",
    description: "A festive template with glowing accents and your profile overlay.",
    image:
      "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=900&q=80",
    isPremium: true,
  },
  {
    id: 3,
    category: "Love",
    title: "Romantic Moments",
    previewText: "Your name shines in the heart of this greeting.",
    description: "A romantic card perfect for sharing love and custom wishes.",
    image:
      "https://images.unsplash.com/photo-1518199266791-5375a83190b7?auto=format&fit=crop&w=900&q=80",
    isPremium: false,
  },
  {
    id: 4,
    category: "Anniversary",
    title: "Anniversary Spark",
    previewText: "A special anniversary wish with your profile at the top.",
    description: "Celebrate a milestone with a premium-looking anniversary card.",
    image:
      "https://images.unsplash.com/photo-1523438885200-e635ba2c371e?auto=format&fit=crop&w=900&q=80",
    isPremium: true,
  },
  {
    id: 5,
    category: "Greeting",
    title: "Morning Cheers",
    previewText: "Start the day with a friendly message carrying your name.",
    description: "A cheerful greeting template for thoughtful daily messages.",
    image:
      "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=900&q=80",
    isPremium: false,
  },
  {
    id: 6,
    category: "Festival",
    title: "Celebration Lights",
    previewText: "May your celebration sparkle with warmth and happiness.",
    description: "A colorful premium festival card for special occasions.",
    image:
      "https://images.unsplash.com/photo-1542291026-7eec264c27ff?auto=format&fit=crop&w=900&q=80",
    isPremium: true,
  },
];

export default templates;
